import React from 'react';

const Dots = () => (
  <div className="dot-loader">
    <div className="dot-flashing" />
  </div>
);

export default Dots;
